class FlickityLarge extends HTMLElement {
  constructor(){
    super();
    this.flickityTop = this.querySelector("[id*='flickity_carousel_product_']");
    this.createFlickity();
    this.imageUrls = this.dataset.imageUrls.split("|");

    this.carouselCell = this.querySelector("[class*='flickity-carousel-cell-class']");

    this.noButtons = this.hasAttribute("no-buttons");
    this.flickityMagnifier = this.hasAttribute("flickity-magnifier");
    this.invisible - this.hasAttribute("invisible");
  }

  connectedCallback () {
    this.noButtons ? this.handleNoButtons() : this.buttonsClickListener();
  }
  
  createFlickity() {
    this.flickity = new Flickity(this.flickityTop, {
      contain: true,
      // setGalleryHeight: false,
      imagesLoaded: true,
      lazyLoad: 1,
      wrapAround: true,
      pageDots: false,
      // {% if product_card_product.images.size < 2 %}
      // prevNextButtons: false,
      // {% endif %}
      adaptiveHeight: true, on: {
        ready: () => {
          // setTimeout(this.removeAttribute("invisible"), 5000);
          this.removeAttribute("hidden");
          // alert("flickity-ready")
        },
        // settle: () => {
    
        // }
      }
    });
    this.flickity.resize();
    console.log(`%c[MassTech / Flickity Custom] flickity large object initialised ${this.noButtons ? "no buttons" : "buttons"}`, "color: green");
    // this.flickity.on('settle', function (index) {alert("flickity settled")});
  }

  buttonsClickListener() {
    this.querySelector(".flickity-slider").addEventListener("click", () => { window.location.href = this.dataset.productUrl});
  }
  handleNoButtons() {
    // this.mfpMetroMag = new MetroMag("mfp-img");
    // this.flickityMetroMag = new MetroMag();

    //set up magnifiers
    // this.mfpMetroMag = new MetroMag("mfp-img");

    // create and attach mfp
    this.mfpObj = new MFP("carousel-cell", "[class*='" + this.carouselCell.classList[0] + " carousel-cell is-selected']", this.flickity, this.mfpMetroMag, this.imageUrls);
    // alert("[class*='" + this.carouselCell.classList[0] + " carousel-cell is-selected']");
    this.mfpObj.create();

    //change mfp index when flickity slider image changed 
    //(no need to recreate the map, only set the index and reattach)
    var self = this;
    this.flickity.on('change', function (index) {
      self.mfpObj.setIndex(index);
      // self.flickityMetroMag.removeWrapper();
    });

    //create flickity magnifier when fklickity started
    this.flickity.on('settle', function () {
      // if(self.flickityMagnifier) { self.flickityMetroMag.createMagnifier(undefined, findImage()); }
    });
    
    function findImage() {
      const FLICKITY_PRODUCT_IMAGE_MAIN = "[class*='carousel product__image-slider'] > [class*='flickity-viewport'] > [class*='flickity-slider'] >  [class*='carousel-cell is-selected'] > img";
      return self.querySelector(FLICKITY_PRODUCT_IMAGE_MAIN);
    }
  }
}
customElements.define('flickity-large', FlickityLarge);

class FlickitySmall extends HTMLElement {
  constructor() {
    super();
    this.flickity;
    this.flickityTop = this.querySelector('.carousel.product__image-thumbnail');
  }

  connectedCallback() {
    this.createFlickity();
  }

  createFlickity() {
    this.flickity = new Flickity(this.flickityTop, {
      asNavFor: '.carousel.product__image-slider',
      contain: true,
      imagesLoaded: true,
      lazyLoad: 4,
      pageDots: false,
      prevNextButtons: false
    });
  }
}

customElements.define('flickity-small', FlickitySmall);